import React from 'react'
import { useNavigate } from 'react-router-dom'
import './index.less'
import { adminIcon, analysisIcon, loginIcon, logoutIcon, mainLogo } from '@/assets/images'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { setAuthority, setToken, setUserId } from '@/features/Login/login'
import { message } from 'antd'
import { authority2path } from '../AuthRouter'

interface HeaderProps {
  hideHeaderBtn?: boolean
}

// 页面头部导航栏组件
export function Header(props: HeaderProps) {
  const { hideHeaderBtn = false } = props
  // 获取token
  const token = useAppSelector((state) => state.login.token)
  // 获取权限
  const authority = useAppSelector((state) => state.login.authority)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const hasAnalysisPagePermission = authority2path[authority]?.includes('/analysis')
  const hasManagePagePermission = authority === 2
  // 返回主页的回调
  const handleBackHome = () => {
    if (token) navigate('/index')
    else navigate('/')
  }
  // 登录页面跳转的回调
  const handleLogin = () => {
    navigate('/')
  }
  // 登出账号的回调
  const handleLogout = () => {
    dispatch(setAuthority(-1))
    dispatch(setToken(''))
    dispatch(setUserId(''))
    message.success('退出成功！')
    navigate('/')
  }
  //分析页面跳转的回调
  const handleAnalysis = () => {
    if (token) {
      if (authority2path[authority].includes('/analysis')) navigate('/analysis')
      //提醒没有权限
      else message.error('对不起, 您没有权限访问分析页面！')
    } else {
      navigate('/')
    }
  }
  //管理页面跳转的回调
  const handleAdmin = () => {
    if (token) {
      if (authority === 2) {
        navigate('/admin')
      } else {
        // 提醒没有权限
        message.error('对不起, 您没有权限访问管理员页面！')
      }
    } else {
      navigate('/')
    }
  }
  return (
    <div className='header-body'>
      <div className='header-title'>
        <img src={mainLogo} alt='大标题' onClick={handleBackHome} />
      </div>
      {!hideHeaderBtn && (
        <div className='header-btn'>
          {token ? (
            <div className='logo' title='退出登录' onClick={handleLogout}>
              <img src={logoutIcon} alt='退出登录' />
            </div>
          ) : (
            <div className='logo' title='登录' onClick={handleLogin}>
              <img src={loginIcon} alt='登录' />
            </div>
          )}
          {/*<div className='logo' title='收藏页面'>*/}
          {/*  <img src={likeIcon} alt='收藏页面' />*/}
          {/*</div>*/}

          {hasAnalysisPagePermission && (
            <div className='logo' title='分析页面' onClick={handleAnalysis}>
              <img src={analysisIcon} alt='分析页面' />
            </div>
          )}

          {hasManagePagePermission && (
            <div className='logo' title='管理员页面' onClick={handleAdmin}>
              <img src={adminIcon} alt='管理员页面' />
            </div>
          )}
        </div>
      )}
    </div>
  )
}
